import React from 'react';
import ChatWindow from '@/components/chat/ChatWindow.tsx';
import { Card } from '@shared';



const Chat: React.FC = () => {
  return (
    <div className="sm:p-6 space-y-9">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-3xl font-bold text-gray-900 hidden sm:block">AI Assistant</h1>
      </div>
      <Card className="flex flex-col border-t border-gray-200 h-[87vh] sm:h-[73vh]">
        <div className="flex-1 overflow-hidden h-150">
          <ChatWindow />
        </div>
      </Card>
    </div>
  )
    ;
};

export default Chat;